import { useState, useEffect } from "react";
import { fetchWithCache } from "../utils/apiCache";

/**
 * Hook para obtener información de contacto desde social_links y Hero
 * Obtiene todos los enlaces para usar en la sección de contacto
 */
export function useContactInfo() {
    const [contactData, setContactData] = useState({
        email: null,
        phone: null,
        location: null,
        socialLinks: [],
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContactInfo = async () => {
            try {
                setLoading(true);
                
                // Obtener social links
                const socialUrl = `${process.env.REACT_APP_BACKEND_URL}/social-links`;
                const socialResult = await fetchWithCache(socialUrl);
                
                // Obtener Hero para location
                const heroUrl = `${process.env.REACT_APP_BACKEND_URL}/hero/`;
                const heroResult = await fetchWithCache(heroUrl);
                
                const socialLinks = socialResult.data || [];
                const heroData = heroResult.data || {};
                
                // Buscar datos de contacto específicos
                const emailLink = socialLinks.find(link => link.name === "Email");
                const phoneLink = socialLinks.find(link => link.name === "Phone");
                
                // Obtener social links visibles (excluir Email, Phone, Descargar CV)
                const visibleSocial = socialLinks
                    .filter(link => 
                        link.is_visible && 
                        !['Email', 'Phone', 'Descargar CV'].includes(link.name)
                    )
                    .sort((a, b) => a.order - b.order);
                
                const data = {
                    email: emailLink ? {
                        value: emailLink.url.replace("mailto:", ""),
                        href: emailLink.url,
                    } : null,
                    phone: phoneLink ? {
                        value: phoneLink.url.replace("tel:", ""),
                        href: phoneLink.url,
                    } : null,
                    location: heroData.location ? {
                        value: heroData.location,
                        href: null,
                    } : null,
                    socialLinks: visibleSocial,
                };
                
                setContactData(data);
                setError(null);
            } catch (err) {
                console.error("Error fetching contact info:", err);
                setError(err.message);
                setContactData({
                    email: null,
                    phone: null,
                    location: null,
                    socialLinks: [],
                });
            } finally {
                setLoading(false);
            }
        };

        fetchContactInfo();
    }, []);

    return {
        contactData,
        loading,
        error,
    };
}
